import React from 'react'
import { IntlProvider } from 'react-intl'
import ReactDOM from 'react-dom/client'
import GlobalStyle from './styles/globalStyles'
import { messages } from './message'
import App from './App'
import QueryProvider from './providers/QueryProvider'

// if (process.env.REACT_APP_ENV === 'development') {
//   worker.start();
// }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <GlobalStyle />
    <IntlProvider locale="en" messages={messages.en}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </IntlProvider>
  </React.StrictMode>,
)
